// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2VVZj","messages":"Chat_messages__yaXYv","dateDivider":"Chat_dateDivider__rypW1"};